<template>
    <div>
     <v-head :title="title"></v-head>
     <div class="banner"><h3>填写相应信息</h3></div>
    <div class="prowt">
        <van-cell-group>
            <van-field
                v-model="params.name"
                placeholder="请输入提案标题"
                readonly 
            />
            <van-field
                v-model="params.title"
                placeholder="请输入提案标题"
            />
        </van-cell-group>
        <van-cell-group>
        <van-field
            v-model="params.content"
            rows="4"
            autosize
            type="textarea"
            maxlength="80"
            placeholder="请输入成为候选人理由"
            show-word-limit
        />
        </van-cell-group>
        <div class="nextBtn">
        <van-button  type="primary" @click="savePD">提交</van-button>
        </div>
     </div>

    </div>
</template>

<script>
import {saveFeedBack,getCurrentAccount} from "@/api/dictionary";
import {Field,CellGroup,RadioGroup,Button,Toast} from 'vant';
import vHead from "../../../components/meuSubHeader.vue";
import {getSessionStore} from "@/utils/sessionStorage.js"
import {mapState} from "vuex";
export default {
  data() {
    return {
        title:"成为候选人",
        params:{
            type: '1',
            name:'',
            title:'',
            content:'',
        }
    };
  },
  components: {
    vHead,
    [Field.name]:Field ,
    [CellGroup.name]:CellGroup,
    [RadioGroup.name]:RadioGroup,
    [Button.name]:Button,
    [Toast.name]:Toast
  },
  methods: {
  ...mapState(["userInfo"]),
    savePD(){
        if(!this.params.title){
            Toast("请输入标题");
            return false;
        }
        if(!this.params.content){
            Toast("请输入反馈内容");
            return false;
        }
        this.params.memberId = getSessionStore("memberId");
       saveFeedBack().then(res=>{
           Toast.success('提交成功');
           this.$router.push({name:"MemberCenter"});
       }) 
    }
  },
  mounted() {
      getCurrentAccount().then(res=>{
          this.params.name = res.result.name
      })
  }
};
</script>
<style scoped>
.banner{ margin-top:55px; background-image: linear-gradient(90deg, #9c4dff 0%, #42a7ff 100%);
  display: flex;align-items: center; height: 100px;}
.banner h3{ text-align: center; color: #fff;font-size: 20px; width: 100%;}
.prowt{ padding:0 4%; margin-top: 40px;}
.prowt .prowt_zs{color: #666;font-size: 14px; line-height: 1.8em;}
.prowt .prowt_bt{color: #000; margin: 20px 0; font-weight: bold; font-size:16px;}
.prowt .prowt_zj{ margin-bottom:15px; display: block; }
.nextBtn{ margin-top: 25px; text-align: center; }
/deep/.van-button--normal{ width: 100%; }
/deep/.prowt .el-form-item__content{ margin-left: 0 !important;}
/deep/.prowt .el-select{ width: 100%;}
/deep/.el-textarea__inner{ font-family:"Microsoft YaHei"; height: 100px;}
/deep/.van-cell{border: #dfdfdf solid 1px; margin-bottom: 15px; border-radius: 5px;}
/deep/.van-radio-group{ overflow: hidden; text-align: center; margin-top:20px;}
/deep/.van-radio{width: 40%; float: left; margin-bottom: 15px;  padding-left: 4.5%}
</style>